import { ChangeEvent, useState } from 'react'
import { toast } from 'react-toastify'
import { useUploadingState } from '../../store/uploadingState'
import fetcher from '../../utils/fetcher'

export interface UploadResponse {
  filesize: number
  mediaId: string
  publishUrl: string
  fileName: string
}

const limitFileSize = 1024 * 1024 * 20 // 20 MB

export default function useUpload(emmiter?: (value: UploadResponse)=>void) {
  const [response, setResponse] = useState<UploadResponse>()
  const [file, setFile] = useState<File|null>(null)

  const [, setUploading] = useUploadingState()

  const handleChange = async (ev:ChangeEvent<HTMLInputElement>)=>{
    const files = Array.from(ev.target.files || [])
    if(!files.length) return

    setFile(files[0])
    
    files.forEach(async file=>{
      const formData = new FormData()
      formData.append('file', file)

      if(file.size>limitFileSize) return toast(`上传失败, 最大支持上传20MB`, {type: 'warning'})

      setUploading(prev=>prev+1)
      const res = await fetcher.post<{filesize: number, mediaId: string, publishUrl: string}>('uploadSFCFile.php', formData)
      setUploading(prev=>prev-1)

      setResponse({...res.data, fileName: file.name})
      if(emmiter) emmiter({...res.data, fileName: file.name})
    })
  }


  return {
    handleChange,
    response,
    file
  }
}